import { createContext } from 'react'

export const EmptyCartContext = createContext('')